import { ArrowRight, Database, Download, FileSpreadsheet } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SolutionDataExportSection = ({ audience = 'founders', bgColor = 'bg-white' }) => {
  const { t, i18n } = useTranslation();
  const language = (i18n.language || 'en').split('-')[0];
  const languagePrefix = language === 'en' ? '' : `/${language}`;
  const content = t(`pageSolutions.dataExport.${audience}`, { returnObjects: true });
  const exportContent = typeof content === 'object' && content ? content : {};
  const bullets = Array.isArray(exportContent.bullets) ? exportContent.bullets : [];
  const bulletItems = Array.isArray(bullets) ? bullets : [];

  return (
    <section className={`border-y border-stone-200 py-14 sm:py-16 ${bgColor}`}>
      <div className="mx-auto grid w-[75%] max-w-screen-xl gap-10 lg:grid-cols-[minmax(0,1fr)_360px] lg:items-center">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full border border-stone-200 bg-stone-50 px-3 py-1 text-xs font-medium text-stone-600">
            <Download className="h-3.5 w-3.5" />
            {t('pageSolutions.dataExport.eyebrow')}
          </div>
          <h2 className="mt-4 max-w-3xl text-3xl font-semibold tracking-tight text-stone-950 sm:text-4xl">
            {exportContent.title}
          </h2>
          <p className="mt-5 max-w-3xl text-base leading-7 text-stone-700">
            {exportContent.description}
          </p>

          <ul className="mt-6 grid gap-3 text-sm leading-6 text-stone-700 sm:grid-cols-3">
            {bulletItems.map((item) => (
              <li key={item} className="flex gap-3">
                <span className="mt-1 h-2 w-2 shrink-0 rounded-full bg-blue-600" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <div className="rounded-md border border-stone-200 bg-stone-50 p-4">
              <Database className="h-5 w-5 text-blue-600" />
              <div className="mt-3 text-sm font-semibold text-stone-950">
                {t('pageSolutions.dataExport.investorsFileName')}
              </div>
            </div>
            <div className="rounded-md border border-stone-200 bg-stone-50 p-4">
              <FileSpreadsheet className="h-5 w-5 text-blue-600" />
              <div className="mt-3 text-sm font-semibold text-stone-950">
                {t('pageSolutions.dataExport.dealsFileName')}
              </div>
            </div>
          </div>
          <Link
            to={`${languagePrefix}/faq/#data-export`}
            className="inline-flex items-center gap-2 text-sm font-semibold text-stone-950 hover:underline"
          >
            {t('pageSolutions.dataExport.faqLink')}
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SolutionDataExportSection;
